export const resolveElement = (target?: HTMLElement | string): HTMLElement => {
  if (!target) {
    return document.body;
  } else if (typeof target === 'string') {
    const $el = document.querySelector(target);
    if (!$el) throw new Error(`${target} is not found`);
    return $el as HTMLElement;
  }
  return target;
};
